
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const ControlMedias = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_CONTROL_MEDIA_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'PRODUCT_CONTROL_MEDIA_ADD':
           
            return { loading: true, error: false, data: [...state.data, action.payload] }
        case 'PRODUCT_CONTROL_MEDIA_ERROR':
            return { loading: false, error: true, data: state };
        case 'PRODUCT_CONTROL_MEDIA_SUCCESS':
            return { loading: false, error: false, data: [...state.data, action.payload] };
        case 'PRODUCT_CONTROL_MEDIA_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default ControlMedias